import { createMuiTheme } from '@material-ui/core/styles';

export default createMuiTheme({
  palette: {
    primary: {
        main:'#42a5f5',
    },
    secondary: {
        main: '#e3f2fd',
    } // Indigo is probably a good match with pink
  },
});